import styled from '@emotion/styled'
import React, { memo } from 'react'

export interface Props {
  category: string
  active?: boolean
  label: string
  onClick?: (e: any) => void
}

export const Filter = memo(function Filter({
  active = false,
  category,
  label,
  onClick,
}: Props) {
  if (!label) {
    return null
  }
  return (
    <Container
      className={active ? 'active' : undefined}
      data-category={category}
      onClick={onClick}
    >
      {label}
    </Container>
  )
})

const Container = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight2};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1rem;
  margin: 1.25rem 1.5rem 0;
  text-transform: uppercase;
  transition: 0.3s ease-out;
  &:hover {
    color: ${({ theme }) => theme.colors.variants.primaryDark1};
  }
  &.active {
    color: ${({ theme }) => theme.colors.variants.neutralDark1};
  }

  @media (max-width: 374px) {
    margin-right: 0.75rem;
    margin-left: 0.75rem;
  }
`
